module.exports = __webpack_public_path__ + "static/img/gzheader.81b2bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzheader.png
// module id = 8
// module chunks = 0